export const apiKey = process.env.REACT_APP_X_NLA_API_KEY;
export const baseUrl = process.env.REACT_APP_API_BASE_URL;
